const LOYALTY_OPTIONS = [
  { value: 'none', label: 'None (first-time)' },
  { value: 'bronze', label: 'Bronze' },
  { value: 'silver', label: 'Silver' },
  { value: 'gold', label: 'Gold' },
];

const STAYS_OPTIONS = [
  { value: 'first_time', label: 'First time' },
  { value: 'few', label: '1–2 visits' },
  { value: 'regular', label: 'Regular (3+)' },
  { value: 'vip', label: 'VIP (10+)' },
];

const GUEST_TYPE_OPTIONS = [
  { value: 'solo', label: 'Solo' },
  { value: 'couple', label: 'Couple' },
  { value: 'family', label: 'Family with kids' },
  { value: 'senior', label: 'Senior couple' },
];

const NATIONALITY_OPTIONS = [
  { value: 'croatian', label: 'Croatian' },
  { value: 'german', label: 'German' },
  { value: 'austrian', label: 'Austrian' },
  { value: 'italian', label: 'Italian' },
  { value: 'british', label: 'British' },
];

const INTEREST_OPTIONS = [
  { value: 'spa', label: 'Spa & wellness' },
  { value: 'sports', label: 'Sports & active' },
  { value: 'dining', label: 'Fine dining' },
  { value: 'family', label: 'Family & kids' },
  { value: 'culture', label: 'Culture' },
];

const STAY_STATUS_OPTIONS = [
  { value: 'arriving_tomorrow', label: 'Arriving tomorrow' },
  { value: 'arriving_today', label: 'Arriving today' },
  { value: 'day_1', label: 'Day 1' },
  { value: 'day_3', label: 'Day 3' },
  { value: 'day_6', label: 'Day 6' },
  { value: 'departing_tomorrow', label: 'Departing tomorrow' },
];

const ROOM_OPTIONS = [
  { value: 'standard', label: 'Standard' },
  { value: 'sea_view', label: 'Sea View' },
  { value: 'junior_suite', label: 'Junior Suite' },
  { value: 'suite', label: 'Suite' },
  { value: 'v_level', label: 'V Level (Pical)' },
];

const BOARD_OPTIONS = [
  { value: 'room_only', label: 'Room only' },
  { value: 'bb', label: 'B&B' },
  { value: 'half_board', label: 'Half Board' },
  { value: 'full_board', label: 'Full Board' },
];

const NIGHTS_OPTIONS = [2, 4, 7, 10];

const SPA_AVAIL_OPTIONS = [
  { value: 'available', label: 'Available' },
  { value: 'limited', label: 'Limited slots' },
  { value: 'full', label: 'Fully booked' },
];

const WEATHER_OPTIONS = [
  { value: 'sunny', label: 'Sunny ☀️' },
  { value: 'cloudy', label: 'Cloudy ⛅' },
  { value: 'rain', label: 'Light rain 🌧️' },
];

const OCCUPANCY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'full', label: 'Full' },
];

function updateCrm(context, patch, onChange) {
  onChange({ ...context, crm: { ...context.crm, ...patch } });
}

function updatePms(context, patch, onChange) {
  onChange({ ...context, pms: { ...context.pms, ...patch } });
}

function updateConditions(context, patch, onChange) {
  onChange({ ...context, conditions: { ...context.conditions, ...patch } });
}

function toggleInterest(context, value, onChange) {
  const current = context.crm.interests || [];
  const next = current.includes(value)
    ? current.filter((i) => i !== value)
    : [...current, value];
  updateCrm(context, { interests: next }, onChange);
}

export default function SystemsPanel({ guestContext, onChange }) {
  const { crm, pms, conditions } = guestContext;

  return (
    <div className="systems-panel">
      <h2 className="systems-panel-title">⚙ Simulating Valamar Systems</h2>
      <p className="systems-panel-sub">
        In production these values come automatically from Dynamics 365 and PHOBS.
        Change them and send the same question — watch the AI respond differently.
      </p>

      <div className="systems-section">
        <div className="systems-section-title">Dynamics 365 — Guest Profile</div>

        <div className="systems-field">
          <label>Guest name</label>
          <input
            type="text"
            value={crm.name || ''}
            onChange={(e) => updateCrm(guestContext, { name: e.target.value }, onChange)}
          />
        </div>

        <div className="systems-field">
          <label>Loyalty tier</label>
          <select
            value={crm.loyaltyTier || 'none'}
            onChange={(e) => updateCrm(guestContext, { loyaltyTier: e.target.value }, onChange)}
          >
            {LOYALTY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Previous stays</label>
          <select
            value={crm.previousStays || 'first_time'}
            onChange={(e) => updateCrm(guestContext, { previousStays: e.target.value }, onChange)}
          >
            {STAYS_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Guest type</label>
          <select
            value={crm.guestType || 'couple'}
            onChange={(e) => updateCrm(guestContext, { guestType: e.target.value }, onChange)}
          >
            {GUEST_TYPE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Nationality</label>
          <select
            value={crm.nationality || 'german'}
            onChange={(e) => updateCrm(guestContext, { nationality: e.target.value }, onChange)}
          >
            {NATIONALITY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Known interests</label>
          <div className="systems-checkboxes">
            {INTEREST_OPTIONS.map((o) => (
              <label key={o.value} className="systems-checkbox">
                <input
                  type="checkbox"
                  checked={(crm.interests || []).includes(o.value)}
                  onChange={() => toggleInterest(guestContext, o.value, onChange)}
                />
                {o.label}
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="systems-section">
        <div className="systems-section-title">PHOBS — Booking Engine</div>

        <div className="systems-field">
          <label>Stay status</label>
          <select
            value={pms.stayStatus || 'day_1'}
            onChange={(e) => updatePms(guestContext, { stayStatus: e.target.value }, onChange)}
          >
            {STAY_STATUS_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Room type</label>
          <select
            value={pms.roomType || 'standard'}
            onChange={(e) => updatePms(guestContext, { roomType: e.target.value }, onChange)}
          >
            {ROOM_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Board type</label>
          <select
            value={pms.boardType || 'half_board'}
            onChange={(e) => updatePms(guestContext, { boardType: e.target.value }, onChange)}
          >
            {BOARD_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Nights booked</label>
          <select
            value={pms.nights || 7}
            onChange={(e) => updatePms(guestContext, { nights: Number(e.target.value) }, onChange)}
          >
            {NIGHTS_OPTIONS.map((n) => (
              <option key={n} value={n}>{n === 10 ? '10+' : n}</option>
            ))}
          </select>
        </div>

        <div className="systems-toggle-row">
          <label className="systems-toggle">
            <input
              type="checkbox"
              checked={!!pms.parkingBooked}
              onChange={(e) => updatePms(guestContext, { parkingBooked: e.target.checked }, onChange)}
            />
            Parking booked
          </label>
          <label className="systems-toggle">
            <input
              type="checkbox"
              checked={!!pms.spaPackageBooked}
              onChange={(e) => updatePms(guestContext, { spaPackageBooked: e.target.checked }, onChange)}
            />
            Spa package
          </label>
        </div>
      </div>

      <div className="systems-section">
        <div className="systems-section-title">Property Conditions</div>

        <div className="systems-field">
          <label>Spa availability</label>
          <select
            value={conditions.spaAvailability || 'available'}
            onChange={(e) => updateConditions(guestContext, { spaAvailability: e.target.value }, onChange)}
          >
            {SPA_AVAIL_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Today&apos;s weather</label>
          <select
            value={conditions.weather || 'sunny'}
            onChange={(e) => updateConditions(guestContext, { weather: e.target.value }, onChange)}
          >
            {WEATHER_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label>Occupancy level</label>
          <select
            value={conditions.occupancy || 'normal'}
            onChange={(e) => updateConditions(guestContext, { occupancy: e.target.value }, onChange)}
          >
            {OCCUPANCY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className="systems-field">
          <label className="systems-toggle">
            <input
              type="checkbox"
              checked={!!conditions.tonightsSpecialEnabled}
              onChange={(e) => updateConditions(guestContext, { tonightsSpecialEnabled: e.target.checked }, onChange)}
            />
            Tonight&apos;s special active
          </label>
        </div>

        {conditions.tonightsSpecialEnabled && (
          <div className="systems-field">
            <label>Special description</label>
            <input
              type="text"
              value={conditions.tonightsSpecial || ''}
              onChange={(e) => updateConditions(guestContext, { tonightsSpecial: e.target.value }, onChange)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
